import styled from "styled-components";

import { Text } from "@src/packages/chime-ui/components/Typography";
import { UnderlinedBoldGhostButton } from "./Button/Button";

const LoginLayout = styled.div`
  text-align: center;
  padding-top: 1rem;
`;

export function LoginPrompt() {
  const url = `${process.env.CONSUMER_HOST}/member/sign_in?src=identity`;

  return (
    <LoginLayout>
      <Text size={"small"}>
        Already a member?{" "}
        <UnderlinedBoldGhostButton as="a" href={url}>
          Log in
        </UnderlinedBoldGhostButton>
      </Text>
    </LoginLayout>
  );
}
